<template>
  <va-card :title="$t('tables.organisations')">
    <template slot="actions">
      <va-button icon="fa fa-refresh" color="info" @click="refresh()" :disabled="loading == true"/>
      <va-button icon="fa fa-gear" color="info" :disabled="loading == true" />
      <va-button icon="fa fa-plus" color="info" :disabled="loading == true" @click="add()"/>
    </template>
    <div class="row">
      <div class="flex xs12">
        <div class="row">
          <div class="flex xs12">
            <va-data-table
              :fields="fields"
              :data="organisations"
              :per-page="15"
              clickable
              :loading="loading"
              hoverable
            >
              <template slot="icon">
                <va-icon name="fa fa-group" color="secondary" />
              </template>
              <template slot="actions" slot-scope="props">
                <va-button
                  flat
                  small
                  color="info"
                  icon="fa fa-pencil"
                  @click="editItem(props.rowData)"
                />
                <va-button
                  flat
                  small
                  color="danger"
                  icon="fa fa-trash"
                  @click="deleteItem(props.rowData)"
                />
              </template>
            </va-data-table>
          </div>
        </div>
      </div>
    </div>
    <div class="modals">
      <div class="flex xs12">
        <va-modal
          size="large"
          max-width="100%"
          v-model="editDialog"
          :title=" $t('modal.editTitle') "
          cancelClass="none"
          :okText=" $t('modal.confirm') "
          :message="message"
          noOutsideDismiss
          noEscDismiss
          @cancel="close"
          @ok="save"
        >
          <div class="form-elements">
            <form>
              <div class="row">
                <div class="flex xs12">
                  <va-input
                    v-model="editedItem.name"
                    placeholder="Organisation Name"
                    label="Organisation Name"
                  ></va-input>
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-select
                    placeholder="Select Administrator"
                    label="Administrator"
                    v-model="editedItem.admin"
                    :options="admins"
                    clearable="false"
                    textBy="full_name"
                    idBy="admin_id"
                  />
                </div>
              </div>
              <div class="row">
                <div class="flex xs12">
                  <va-select
                    placeholder="Select Account Manager"
                    label="Account Manager"
                    v-model="editedItem.account_manager"
                    :options="accountManagers"
                    clearable="false"
                    textBy="full_name"
                    idBy="account_manager_id"
                  />
                </div>
              </div>
            </form>
          </div>
        </va-modal>
      </div>
    </div>
  </va-card>
</template>

<script>
import organisationService from '../../../api/organisationService'
import dataFactory from '../../../api/dataFactoryService'

export default {
  data () {
    return {
      loading: false,
      editDialog: false,
      deleteDialog: false,
      organisations: [],
      admins: [],
      message: '',
      accountManagers: [],
      editedIndex: -1,
      editedItem: {
        id: '',
        name: '',
        inactive: false,
        inactive_text: 'active',
        admin_id: '',
        account_manager_id: '',
        admin: {
          admin_id: '',
          full_name: '',
        },
        account_manager: {
          account_manager_id: '',
          full_name: '',
        },
      },
      defaultItem: {
        id: '',
        name: '',
        inactive: false,
        inactive_text: 'active',
        admin_id: '',
        account_manager_id: '',
        admin: {
          admin_id: '',
          full_name: '',
        },
        account_manager: {
          account_manager_id: '',
          full_name: '',
        },
      },
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:icon',
          width: '30px',
        },
        {
          name: 'name',
          title: this.$t('tables.organisationHeadings.name'),
          sortField: 'name',
          width: '30%',
        },
        {
          name: 'admin.full_name',
          title: this.$t('tables.organisationHeadings.admin'),
          width: '25%',
        },
        {
          name: 'account_manager.full_name',
          title: this.$t('tables.organisationHeadings.accountManager'),
          width: '25%',
        },
        {
          name: '__slot:actions',
          dataClass: 'text-right',
          width: '50px',
        },
      ]
    },
  },

  watch: {
    editDialog (val) {
      // val || this.close()
      if (val) {
        console.log('close called')
      }
    },
  },

  async created () {
    await this.initialize()
  },

  methods: {
    async refresh () {
      await this.initialize()
      console.log('refresh')
    },
    async initialize () {
      this.loading = true
      try {
        let orgsResult = await organisationService.getActive()
        this.admins = dataFactory.createAdminViewListModel(
          orgsResult.payload.data.administrators
        )
        this.accountManagers = dataFactory.createAccountManagerViewListModel(
          orgsResult.payload.data.managers
        )
        this.organisations = dataFactory.createOragnisationListModel(
          orgsResult.payload.data.organisations,
          this.admins,
          this.accountManagers
        )
      } catch (error) {
        this.showToast(error, {
          icon: 'fa-exclamation',
          position: 'bottom-right',
          duration: 5000,
        })
      }
      this.loading = false
    },

    editItem (item) {
      this.editedIndex = this.organisations.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.editDialog = true
      this.message = "Edit the selected organisation. Make sure the organisation's name is unique in system."
    },

    async deleteItem (item) {
      const index = this.organisations.indexOf(item)
      if (confirm('Are you sure you want to delete this item?')) {
        try {
          await organisationService.delete(item.id)
          this.organisations.splice(index, 1)
        } catch (error) {
          this.showToast(error, {
            icon: 'fa-exclamation',
            position: 'bottom-right',
            duration: 5000,
          })
        }
      }
    },

    close () {
      this.editDialog = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
    },

    async save () {
      // try {
      this.editedItem.admin_id = this.editedItem.admin.admin_id
      this.editedItem.account_manager_id = this.editedItem.account_manager.account_manager_id
      if (this.editedIndex > -1) {
        await organisationService.update(this.editedItem.id, this.editedItem)
        this.organisations[this.editedIndex] = Object.assign(this.organisations[this.editedIndex], this.editedItem)
      } else {
        var creationResult = await organisationService.create(this.editedItem)
        this.editedItem.id = creationResult.payload.data
        this.organisations.push(this.editedItem)
      }
      this.editedItem = Object.assign({}, this.defaultItem)
      this.editedIndex = -1
      // } catch (error) {
      //   console.log(error)
      //   this.showToast(error, {
      //     icon: 'fa-exclamation',
      //     position: 'bottom-right',
      //     duration: 5000,
      //   })
      // }
      this.editDialog = false
    },

    add () {
      this.editDialog = true
      this.message = "Add a new organisation to the system. Make sure the organisation's name is unique in system."
    },
  },
}
</script>

<style lang="scss">
</style>
